module.exports = __webpack_public_path__ + "img/OPAL-alt.4523f69e.svg";